
import page from "~/layouts/testimonial.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Création de site internet pour Garagiste | Agence ALEO",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Ce garagiste nous a confié sa visibilité sur la toile. La concurrence faisant rage, notre client cherchait un moyen de se démarquer efficacement et à petit prix. ",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Site web & référencement",
        },
        {
          hid: "og:description",
          property: "og:description",
          content: "Garage Didier témoigne",
        },
        // {
        //   hid: "og:image",
        //   property: "og:image",
        //   content: require("~/assets/img/case-studies/mockup-garage-didier.jpg"),
        // },
      ],
    };
  },
};
